import React, { useState } from "react";

import { Box, Checkbox, Divider, styled, Typography } from "@mui/material";
import AirplaneTicketIcon from "@mui/icons-material/AirplaneTicket";
import PaymentsIcon from "@mui/icons-material/Payments";
import ClearIcon from "@mui/icons-material/Clear";
import LuggageIcon from "@mui/icons-material/Luggage";
const OptionListItem = styled(Typography)({
  fontSize: "12px",
  color: "grayText",
});
type Props = {
  checked: boolean;
};
const FareCard = ({ checked }: Props) => {
  const [isChecked, setIsCheked] = useState<boolean>(false);
  return (
    <div
      style={{
        flex: 1,
        backgroundColor: checked ? "#E6DAFB" : "#FFFFFF",
        padding: checked ? "3.5px" : "0px",
        borderRadius: "3px",
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          backgroundColor: "#FFFFFF",
          borderRadius: "3px",
          padding: "15px",
          borderWidth: "1px",
          borderColor: checked ? "#9576DB" : "gray",
          "&: hover": {
            border: "1px solid #9576DB",
          },
        }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}>
            <Typography variant="body1" component="code">
              ECONOMY
            </Typography>
            <Typography variant="h6" component="code">
              Resctricted
            </Typography>
          </Box>
          <Box>
            <Checkbox checked={checked} color="success" />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}>
          <Divider orientation="horizontal" />

          <OptionListItem variant="body1">
            <AirplaneTicketIcon fontSize="small" /> No data on changes
          </OptionListItem>
          <OptionListItem variant="body1">
            <PaymentsIcon fontSize="small" /> No data on refunds
          </OptionListItem>
          <OptionListItem variant="body1">
            <ClearIcon fontSize="small" /> No carry-on bags
          </OptionListItem>
          <OptionListItem variant="body1">
            <LuggageIcon fontSize="small" /> Included 2 checked bags
          </OptionListItem>

          <Divider orientation="horizontal" />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}>
          <Typography variant="body1">Total amount from</Typography>
          <Typography variant="h6">€768.39</Typography>
        </Box>
      </Box>
    </div>
  );
};

export default FareCard;
